import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=2192e6a6&"
import script from "./ClientLayout.vue?vue&type=script&lang=ts&"
export * from "./ClientLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports